import axios from 'axios'
import { isFunction as _isFunction } from 'lodash'
import { retrieveUtilities } from '@vfgroup-oneplatform/foundation/Utils/ServicesUtils/Utilities'

import { API_URLS } from './Config'

const GetOfferDetails = async (
  type,
  status,
  channelId,
  msisdn,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const data = {
    params: {
      type: type,
      status: status,
      channelId: channelId,
      customerAccountId: msisdn,
    },
    data: null,
    headers: customHeaders
  }

  onStart()

  try {
    const response = await axios.get(API_URLS.getOfferDetails, data)

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

const ActivateOffer = async (
  id,
  msisdn,
  name,
  type,
  category,
  status,
  overwriteItems,
  bundleAction,
  customHeaders = {},
  utilities = {},
) => {
  const _utilities = retrieveUtilities(utilities)

  const { onStart, onSuccess, onError, responseMapper, errorMapper } = _utilities

  const requestBody = {
    id: id,
    type: type,
    category: category,
    status: status,
    relatedParty: [
      {
        id: msisdn,
      },
    ],
    customerAccount: {
      id: {
        value: msisdn,
      },
    },
    channel: {
      id: {
        value: 'myvodafone',
      },
    },
    lineItem: [
      {
        productOffering: [
          {
            id: id?.[0],
            href: bundleAction,
            name: name,
            category: category,
          },
          ...overwriteItems,
        ],
      },
    ],
  }

  const data = requestBody

  onStart()

  try {
    const response = await axios.post(API_URLS.activateOffer, data, { headers: customHeaders })

    const _response = responseMapper(response)
    onSuccess(_response)
    return _response
  } catch (error) {
    const _error = errorMapper(error)

    if (_isFunction(onError)) {
      onError(_error)
    } else {
      throw _error
    }
  }
}

export { GetOfferDetails, ActivateOffer }
